module.exports = __webpack_public_path__ + "static/media/congratulations_modal_logo.1b41e79d.svg";